// removed by extract-text-webpack-plugin
module.exports = {"font":"_2LEjmI7UbzEa2SCl7M21J","heading":"_21WiKn6hHqnORNgo7BZe1e","size14":"_3sVUgZ2kVZMHPLdGmxOOa6","size15":"_11_40UH3RY5ssIJajg16Z-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Font/style.css
// module id = 227
// module chunks = 42